import React from 'react';
import { BUSINESS, DELIVERY, fullAddress } from './businessInfo';

// Terms & Conditions.
//
// A plain-language draft covering what a payment gateway review looks for:
// who the seller is, how an order is formed, how prices and taxes are stated,
// how payment is taken, and which courts apply. It is not legal advice — have it
// read by the client's advisor before launch, and expect them to change wording.
//
// One <section> per numbered heading: spacing on a phone, cards of a grid on a
// computer. The date and the opening paragraph span the page above them.

const TermsConditions = () => (
    <div className="so-infopage">
        <p className="so-infopage__meta">
            Last updated: {BUSINESS.lastUpdated}
        </p>

        <p className="so-infopage__lead">
            These terms apply when you order from {BUSINESS.brandName} through this site.
            By placing an order you agree to them. The seller is{' '}
            <strong>{BUSINESS.legalName || BUSINESS.fullName}</strong>, {fullAddress()}.
        </p>

        <section className="so-infopage__section">
            <h3>1. Orders</h3>
            <ul>
                <li>
                    An order is a request until we confirm it. Confirmation is the order number
                    shown after payment.
                </li>
                <li>
                    A special order is prepared for the date and time you select. Please allow at
                    least {DELIVERY.preOrderNoticeHours} hours' notice.
                </li>
                <li>
                    We may decline or cancel an order — an item is unavailable, the address is
                    outside our delivery area, the order cannot be cooked on that date, or we
                    have reason to believe the order is not genuine. If we cancel, you are
                    refunded in full.
                </li>
                <li>
                    Please tell us before ordering about any allergy or dietary requirement. Our
                    kitchen handles milk, nuts, gluten and seafood, and we cannot guarantee that
                    any dish is free of traces of them.
                </li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>2. Prices and taxes</h3>
            <ul>
                <li>
                    All prices are in Indian Rupees ({BUSINESS.currencySymbol}) and are the prices
                    shown on the site at the time you order.
                </li>
                <li>
                    Applicable taxes are charged as required by law and shown before you pay,
                    along with any delivery or packing charge.
                </li>
                <li>
                    Menu items, offers and prices can change without notice. An offer applies only
                    while it is shown and only to orders placed while it is live.
                </li>
                <li>
                    If an item is priced wrongly by obvious error, we will contact you before
                    preparing the order and you may confirm at the correct price or cancel for a
                    full refund.
                </li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>3. Payment</h3>
            <ul>
                <li>
                    Online payments are processed by our payment gateway. We do not see or store
                    your card number, CVV, PIN or UPI credentials.
                </li>
                <li>
                    An order is confirmed only when the gateway confirms the payment. If a payment
                    fails, no order is placed; any amount debited is reversed as described in the
                    Refund &amp; Cancellation policy.
                </li>
                <li>
                    You confirm that the payment instrument you use is yours or that you are
                    authorised to use it.
                </li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>4. Cancellations and refunds</h3>
            <p>
                Cancellations, refunds and what happens if an order goes wrong are covered in the
                Refund &amp; Cancellation policy, which forms part of these terms. Delivery,
                pickup and delays are covered in the Delivery &amp; Pickup policy.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>5. Your information</h3>
            <p>
                We use the name, phone number and address you give us to prepare and deliver your
                order and to contact you about it. How we handle your information is set out in the
                Privacy Policy.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>6. Using this site</h3>
            <ul>
                <li>Please give accurate contact and address details — orders fail without them.</li>
                <li>
                    Do not use the site to place false orders, to interfere with its working, or to
                    copy its content, branding or photographs for your own use.
                </li>
                <li>
                    We may suspend ordering for maintenance or for reasons outside our control, and
                    we do not promise the site will always be available.
                </li>
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>7. Our responsibility</h3>
            <p>
                We are responsible for the food we supply and for refunding you where these terms
                say so. Beyond that, and to the extent the law allows, our liability for any order
                is limited to the amount you paid for it. Nothing here limits any right you have
                under consumer law.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>8. Governing law</h3>
            <p>
                These terms are governed by the laws of India
                {BUSINESS.jurisdictionCity
                    ? <>, and the courts at {BUSINESS.jurisdictionCity} have jurisdiction.</>
                    : <>.</>}
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>9. Changes</h3>
            <p>
                We may update these terms; the version on this page when you order is the one that
                applies to that order.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>10. Contact</h3>
            <p>
                Questions about these terms: call us on {BUSINESS.phone}
                {BUSINESS.email ? ', or write to ' + BUSINESS.email : ''}. Our address is
                on the Contact us page.
            </p>
        </section>
    </div>
);

export default TermsConditions;
